import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/translation.json";
import pt from "./locales/pt/translation.json";
import enDdisCommon from "./locales/en/ddis_common.json";
import ptDdisCommon from "./locales/pt/ddis_common.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: pt, ddis_common: ptDdisCommon },
      en: { translation: en, ddis_common: enDdisCommon },
    },
    fallbackLng: "pt",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
